import { render } from "./PeriodicData.vue?vue&type=template&id=630fa8d5&scoped=true"
import script from "./PeriodicData.vue?vue&type=script&lang=js"
export * from "./PeriodicData.vue?vue&type=script&lang=js"

import "./PeriodicData.vue?vue&type=style&index=0&id=630fa8d5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630fa8d5"]])

export default __exports__